(function () {
  'use strict';
  var S = window.themeStrings || {};
  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var mqMobile = window.matchMedia('(max-width: 749px)');
  var finePointer = window.matchMedia('(pointer: fine)');
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var onChange = function (mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); };
  var raf = function (fn) { var queued = false; return function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; fn(); }); }; };

  /* ------------------------------------------------------------------
     Header: height variable + smart sticky (hide on scroll down)
     ------------------------------------------------------------------ */
  var headerSection = document.querySelector('.section-header');
  function setHeaderHeight() {
    if (headerSection) root.style.setProperty('--header-h', headerSection.offsetHeight + 'px');
  }
  setHeaderHeight();
  if (headerSection && 'ResizeObserver' in window) new ResizeObserver(setHeaderHeight).observe(headerSection);

  if (headerSection && headerSection.querySelector('.header--sticky')) {
    var lastY = window.scrollY;
    var onHeaderScroll = raf(function () {
      var y = window.scrollY;
      headerSection.classList.toggle('is-scrolled', y > 8);
      var keepVisible = root.classList.contains('scroll-lock') || headerSection.querySelector('.nav-list__item.is-open');
      if (!keepVisible && y > lastY + 2 && y > headerSection.offsetHeight + 240) {
        headerSection.classList.add('is-hidden');
      } else if (y < lastY - 6 || y < 120) {
        headerSection.classList.remove('is-hidden');
      }
      lastY = y;
    });
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    headerSection.addEventListener('focusin', function () { headerSection.classList.remove('is-hidden'); });
    onHeaderScroll();
  }

  /* ------------------------------------------------------------------
     Announcement rotator
     ------------------------------------------------------------------ */
  each(document.querySelectorAll('[data-rotator]'), function (track) {
    var items = track.children;
    if (items.length < 2) return;
    var i = 0;
    var paused = false;
    track.addEventListener('mouseenter', function () { paused = true; });
    track.addEventListener('mouseleave', function () { paused = false; });
    track.addEventListener('focusin', function () { paused = true; });
    track.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      var current = items[i];
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      setTimeout(function () { current.classList.remove('is-leaving'); }, 700);
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 5000);
  });

  /* ------------------------------------------------------------------
     Desktop dropdowns (hover via CSS; click/keyboard via toggle)
     ------------------------------------------------------------------ */
  var dropdowns = document.querySelectorAll('[data-dropdown]');
  function closeDropdowns(except) {
    each(dropdowns, function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var b = item.querySelector('.nav-list__toggle');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  each(dropdowns, function (item) {
    var btn = item.querySelector('.nav-list__toggle');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = !item.classList.contains('is-open');
      closeDropdowns(item);
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) { closeDropdowns(); btn.focus(); }
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-dropdown]')) closeDropdowns(); });

  /* ------------------------------------------------------------------
     Menu drawer (phones & tablets)
     ------------------------------------------------------------------ */
  var drawer = document.querySelector('[data-drawer]');
  var drawerOpenBtn = document.querySelector('[data-drawer-open]');
  if (drawer && drawerOpenBtn) {
    // Move out of the sticky header so `position: fixed` is relative to the viewport.
    document.body.appendChild(drawer);
    var panel = drawer.querySelector('.drawer__panel');
    var lastFocus = null;
    var closeTimer;
    var focusables = function () {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), select, input:not([type=hidden])'),
        function (el) { return !el.closest('[inert]') && el.getClientRects().length > 0; }
      );
    };
    var openDrawer = function () {
      clearTimeout(closeTimer);
      lastFocus = document.activeElement;
      drawer.hidden = false;
      root.classList.add('scroll-lock', 'drawer-open');
      drawerOpenBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          var first = drawer.querySelector('.drawer__close');
          if (first) first.focus({ preventScroll: true });
        });
      });
    };
    var closeDrawer = function (restoreFocus) {
      if (drawer.hidden) return;
      drawer.classList.remove('is-open');
      drawerOpenBtn.setAttribute('aria-expanded', 'false');
      root.classList.remove('scroll-lock', 'drawer-open');
      closeTimer = setTimeout(function () { drawer.hidden = true; }, reduceMotion.matches ? 0 : 560);
      if (restoreFocus !== false && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    drawerOpenBtn.addEventListener('click', openDrawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
      var toggle = e.target.closest('[data-drawer-sub-toggle]');
      if (toggle) {
        var sub = document.getElementById(toggle.getAttribute('aria-controls'));
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        if (sub) {
          sub.classList.toggle('is-open', !expanded);
          if (expanded) sub.setAttribute('inert', ''); else sub.removeAttribute('inert');
        }
        return;
      }
      if (e.target.closest('a[href]')) closeDrawer(false);
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    onChange(mqDesktop, function (m) { if (m.matches) closeDrawer(false); });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { drawer.classList.remove('is-open'); drawer.hidden = true; root.classList.remove('scroll-lock', 'drawer-open'); drawerOpenBtn.setAttribute('aria-expanded', 'false'); }
    });
  }

  /* ------------------------------------------------------------------
     Auto-submit selects / filters (cart quantity is debounced)
     ------------------------------------------------------------------ */
  var cartTimer;
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.matches || !el.matches('[data-autosubmit]')) return;
    var form = el.form;
    if (!form) return;
    if (form.id === 'CartForm') {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () {
        var update = form.querySelector('[name="update"]');
        if (update) update.click(); else form.submit();
      }, 450);
      return;
    }
    form.submit();
  });

  /* Login: toggle recover password */
  each(document.querySelectorAll('[data-toggle-recover]'), function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var r = document.getElementById('RecoverForm');
      var l = document.getElementById('LoginForm');
      if (!r || !l) return;
      r.hidden = !r.hidden;
      l.hidden = !l.hidden;
    });
  });
  if (location.hash === '#recover') {
    var rf = document.getElementById('RecoverForm');
    var lf = document.getElementById('LoginForm');
    if (rf && lf) { rf.hidden = false; lf.hidden = true; }
  }

  /* ------------------------------------------------------------------
     Quantity buttons (product page + cart)
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qty, 10));
    if (String(next) === input.value) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------
     Accordions with smooth height animation
     ------------------------------------------------------------------ */
  each(document.querySelectorAll('[data-accordion]'), function (d) {
    var summary = d.querySelector('summary');
    var content = d.querySelector('.accordion__content');
    if (!summary || !content || !content.animate) return;
    summary.addEventListener('click', function (e) {
      if (reduceMotion.matches) return;
      e.preventDefault();
      if (d.dataset.animating) return;
      d.dataset.animating = '1';
      var easing = 'cubic-bezier(.22,1,.36,1)';
      if (d.open) {
        var h = content.offsetHeight;
        var close = content.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 360, easing: easing });
        close.onfinish = function () { d.open = false; delete d.dataset.animating; };
      } else {
        d.open = true;
        var h2 = content.offsetHeight;
        var open = content.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 460, easing: easing });
        open.onfinish = function () { delete d.dataset.animating; };
      }
    });
  });

  /* ------------------------------------------------------------------
     Collection filters (popovers on desktop, bottom sheet on phones)
     ------------------------------------------------------------------ */
  var filters = document.querySelectorAll('[data-filter]');
  var filterBackdrop = document.querySelector('[data-filter-backdrop]');
  if (filters.length) {
    var syncFilters = function () {
      var anyOpen = Array.prototype.some.call(filters, function (f) { return f.open; });
      var sheet = anyOpen && mqMobile.matches;
      if (filterBackdrop) filterBackdrop.hidden = !sheet;
      root.classList.toggle('scroll-lock', sheet);
    };
    var closeFilters = function () { each(filters, function (f) { f.open = false; }); };
    each(filters, function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) each(filters, function (o) { if (o !== d) o.open = false; });
        syncFilters();
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-close]') || e.target.closest('[data-filter-backdrop]')) { closeFilters(); return; }
      if (!e.target.closest('[data-filter]')) closeFilters();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      each(filters, function (f) { if (f.open) { f.open = false; f.querySelector('summary').focus(); } });
    });
    onChange(mqMobile, syncFilters);
  }

  /* ------------------------------------------------------------------
     Swipe rails (featured products on phones) + progress bar
     ------------------------------------------------------------------ */
  function initRail(rail) {
    if (rail.dataset.railReady) return;
    rail.dataset.railReady = '1';
    var bar = document.createElement('div');
    bar.className = 'rail-progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span></span>';
    rail.parentNode.insertBefore(bar, rail.nextSibling);
    var fill = bar.firstChild;
    var update = raf(function () {
      var max = rail.scrollWidth - rail.clientWidth;
      bar.hidden = max <= 4;
      if (max <= 4) return;
      var visible = rail.clientWidth / rail.scrollWidth;
      var progress = Math.min(1, visible + (Math.abs(rail.scrollLeft) / max) * (1 - visible));
      fill.style.setProperty('--progress', progress.toFixed(3));
    });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  each(document.querySelectorAll('[data-rail]'), initRail);

  /* ------------------------------------------------------------------
     Product: gallery, variants, sticky add-to-bag
     ------------------------------------------------------------------ */
  each(document.querySelectorAll('[data-product-section]'), function (section) {
    var track = section.querySelector('[data-gallery-track]');
    var slides = section.querySelectorAll('.product__slide');
    var thumbs = section.querySelectorAll('[data-thumb]');
    var dots = section.querySelectorAll('[data-dot]');

    function setActive(id) {
      var found = false;
      each(slides, function (s) {
        var match = String(s.dataset.mediaId) === String(id);
        if (match) found = true;
        s.classList.toggle('is-active', match);
      });
      if (!found && slides[0]) slides[0].classList.add('is-active');
      each(thumbs, function (t) { t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)); });
      each(dots, function (d) { d.classList.toggle('is-active', String(d.dataset.dot) === String(id)); });
    }
    function showMedia(id) {
      if (!id) return;
      setActive(id);
      if (!mqDesktop.matches && track) {
        var slide = track.querySelector('.product__slide[data-media-id="' + id + '"]');
        if (slide && track.scrollWidth > track.clientWidth) {
          track.scrollTo({ left: slide.offsetLeft - track.firstElementChild.offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        }
      }
    }
    each(thumbs, function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });
    if (track && slides.length > 1) {
      track.addEventListener('scroll', raf(function () {
        if (mqDesktop.matches) return;
        var index = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
        var slide = slides[Math.min(index, slides.length - 1)];
        if (slide) setActive(slide.dataset.mediaId);
      }), { passive: true });
    }

    var form = section.querySelector('[data-product-form]');
    var addBtn = form && form.querySelector('[data-add-button]');
    var sticky = section.querySelector('[data-sticky-atc]');
    var stickyBtn = sticky && sticky.querySelector('[data-sticky-add]');
    var stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');

    var jsonEl = section.querySelector('[data-product-json]');
    var product = null;
    try { product = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (err) { product = null; }
    var priceWrap = section.querySelector('[data-price]');

    function formatMoney(cents) {
      try {
        var cur = document.documentElement.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED';
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    }

    if (product && form && addBtn) {
      var select = form.querySelector('[data-variant-select]');
      var selectedOptions = function () {
        return product.options.map(function (_, idx) {
          var checked = form.querySelector('input[name="option' + (idx + 1) + '"]:checked');
          return checked ? checked.value : null;
        });
      };
      var update = function () {
        var opts = selectedOptions();
        var variant = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!variant) {
          addBtn.disabled = true;
          addBtn.textContent = S.unavailable || 'Unavailable';
          if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = addBtn.textContent; }
          return;
        }
        select.value = variant.id;
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? (S.addToCart || 'Add to cart') : (S.soldOut || 'Sold out');
        if (stickyBtn) { stickyBtn.disabled = addBtn.disabled; stickyBtn.textContent = addBtn.textContent; }
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        if (priceWrap) {
          var cur = priceWrap.querySelector('.price__current');
          var cmp = priceWrap.querySelector('.price__compare');
          var priceEl = priceWrap.querySelector('.price');
          if (cur) cur.textContent = formatMoney(variant.price);
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            if (!cmp) { cmp = document.createElement('s'); cmp.className = 'price__compare'; priceEl.appendChild(cmp); }
            cmp.textContent = formatMoney(variant.compare_at_price);
            priceEl.classList.add('price--sale');
          } else {
            if (cmp) cmp.remove();
            priceEl.classList.remove('price--sale');
          }
        }
        if (variant.featured_media) showMedia(variant.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      };
      form.addEventListener('change', function (e) { if (e.target.matches('[data-option-input]')) update(); });
    }

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.footer');
      var buttonPassed = false;
      var footerInView = false;
      var syncSticky = function () {
        var show = buttonPassed && !footerInView && !mqDesktop.matches;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
        root.classList.toggle('has-sticky-atc', show);
        root.style.setProperty('--sticky-atc-h', sticky.offsetHeight + 'px');
      };
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        buttonPassed = !en.isIntersecting && en.boundingClientRect.top < 0;
        syncSticky();
      }).observe(addBtn);
      if (footer) new IntersectionObserver(function (entries) { footerInView = entries[0].isIntersecting; syncSticky(); }).observe(footer);
      onChange(mqDesktop, syncSticky);
      stickyBtn && stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }
  });

  /* ------------------------------------------------------------------
     AJAX add to cart + toast
     ------------------------------------------------------------------ */
  var toast = document.getElementById('CartToast');
  var toastTimer;
  function showToast(text) {
    if (!toast) return;
    toast.querySelector('.toast__text').textContent = text;
    toast.hidden = true;
    void toast.offsetWidth; // restart entrance animation
    toast.hidden = false;
    root.classList.add('toast-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; root.classList.remove('toast-open'); }, 4000);
  }
  function updateCount() {
    fetch((window.routes ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        each(document.querySelectorAll('[data-cart-count]'), function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
          el.classList.remove('is-bumped');
          void el.offsetWidth;
          el.classList.add('is-bumped');
        });
      }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('js-add-to-cart')) return;
    if (e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var section = form.closest('[data-product-section]');
    var stickyBtn = section && section.querySelector('[data-sticky-add]');
    [btn, stickyBtn].forEach(function (b) { if (b) b.setAttribute('aria-busy', 'true'); });
    var url = (window.routes ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { showToast(res.data.description || res.data.message || S.error); return; }
        showToast(S.added || 'Added');
        updateCount();
      })
      .catch(function () { form.submit(); })
      .finally(function () { [btn, stickyBtn].forEach(function (b) { if (b) b.removeAttribute('aria-busy'); }); });
  });

  /* ------------------------------------------------------------------
     Scroll reveal (transform + opacity only)
     ------------------------------------------------------------------ */
  var REVEAL = '.section-head, .card, .family, .perk, .pyramid__tier, .split__content, .split__media, .collection-hero, .collection-tile, .footer__grid > *, .newsletter-form, .notes, .cart__summary';
  var io = null;
  if ('IntersectionObserver' in window && !reduceMotion.matches) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  }
  function observeReveals(scope) {
    if (!io) return;
    var phone = mqMobile.matches;
    each(scope.querySelectorAll(REVEAL), function (el) {
      if (el.hasAttribute('data-reveal') || el.closest('.product__info, .drawer, .hero')) return;
      if (phone && el.closest('.grid--rail')) return;
      var siblings = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(REVEAL); }) : [];
      var index = Math.max(0, siblings.indexOf(el));
      el.style.setProperty('--reveal-i', String(index % (phone ? 2 : 4)));
      el.setAttribute('data-reveal', '');
      io.observe(el);
    });
    if (phone) {
      each(scope.querySelectorAll('.grid--rail'), function (rail) {
        if (rail.hasAttribute('data-reveal')) return;
        rail.setAttribute('data-reveal', '');
        io.observe(rail);
      });
    }
  }
  observeReveals(document);

  /* ------------------------------------------------------------------
     Product recommendations (loaded after page render)
     ------------------------------------------------------------------ */
  each(document.querySelectorAll('[data-recommendations]'), function (el) {
    if (!el.dataset.url || el.children.length) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim().length) {
          el.innerHTML = inner.innerHTML;
          each(el.querySelectorAll('[data-rail]'), initRail);
          observeReveals(el);
        } else {
          el.remove();
        }
      }).catch(function () {});
  });

  /* ------------------------------------------------------------------
     WhatsApp button: reveal after the first screen
     ------------------------------------------------------------------ */
  var whatsapp = document.querySelector('[data-whatsapp]');
  if (whatsapp) {
    var syncWhatsapp = raf(function () { whatsapp.classList.toggle('is-shown', window.scrollY > window.innerHeight * 0.45); });
    window.addEventListener('scroll', syncWhatsapp, { passive: true });
    syncWhatsapp();
  }

  /* ------------------------------------------------------------------
     Hero parallax (desktop pointers only, transform-only)
     ------------------------------------------------------------------ */
  var parallax = document.querySelector('[data-hero] [data-parallax]');
  if (parallax && !reduceMotion.matches && finePointer.matches && 'IntersectionObserver' in window) {
    var hero = parallax.closest('[data-hero]');
    var factor = hero.classList.contains('hero--layout-split') ? 0.06 : 0.2;
    var heroInView = true;
    new IntersectionObserver(function (en) { heroInView = en[0].isIntersecting; }).observe(hero);
    window.addEventListener('scroll', raf(function () {
      if (!heroInView) return;
      parallax.style.transform = 'translate3d(0,' + (window.scrollY * factor).toFixed(1) + 'px,0)';
    }), { passive: true });
  }
})();
